document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.kikuyo-recommendations').forEach((recommendations) => {
    const list = recommendations.querySelector('.kikuyo-recommendations__list');
    const controls = recommendations.querySelector('.kikuyo-recommendations__controls');
    const prev = controls?.querySelector('[data-kikuyo-recommendations-scroll="-1"]');
    const next = controls?.querySelector('[data-kikuyo-recommendations-scroll="1"]');

    if (!list) return;

    const updateControls = () => {
      if (!controls) return;

      const { scrollLeft, scrollWidth, clientWidth } = list;
      const overflow = scrollWidth - clientWidth;

      if (overflow <= 1) {
        // Nothing to scroll: hide the arrows entirely.
        controls.hidden = true;
      } else {
        controls.hidden = false;
        if (prev) prev.disabled = scrollLeft <= 1;
        if (next) next.disabled = scrollLeft >= overflow - 1;
      }
    };

    list.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls);

    if ('ResizeObserver' in window) {
      new ResizeObserver(updateControls).observe(list);
    }

    // Re-evaluate once after layout settles (images/fonts can shift widths).
    requestAnimationFrame(updateControls);

    updateControls();
  });
});

document.addEventListener('click', (event) => {
  const control = event.target.closest('[data-kikuyo-recommendations-scroll]');

  if (!control || control.disabled) return;

  const list = document.getElementById(control.getAttribute('aria-controls'));

  if (!list) return;

  list.scrollBy({
    left: list.clientWidth * Number(control.dataset.kikuyoRecommendationsScroll),
    behavior: 'smooth'
  });
});
